<textarea #editorContainer
          [attr.aria-label]="'aria.label.textEditor' | translate"
          role="textbox"
          aria-multiline="true"
>
</textarea>
